import { useContent } from "contexts/contentContext/contentContext";
import React from "react";
import { useParams } from "react-router-dom";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const SideList = ({ categories, isSkeleton = null }) => {
  const { getTextByKey } = useContent();
  const params = useParams();

  return (
    <div className="support-side-list">
      <h3>{getTextByKey("support-categories")}</h3>
      {!isSkeleton ? categories.map((category) => {
        return (
          <a
            href={`${
              category.SystemName === "jumbo-embed"
                ? "jumbo-forms"
                : category.SystemName
            }`}
            key={category.SupportCategoryId}
            className="side-question-link"
          >
            <div
              className={
                category.SystemName === params.isQuestion
                  ? "support-question-color"
                  : category.SystemName === "jumbo-embed" &&
                    params.supportCategory === "jumbo-forms"
                  ? "support-question-color"
                  : null
              }
            >
              {category.CategoryTitle === "JUMBOembed" ? "JUMBOforms" : category.CategoryTitle}
            </div>
          </a>
        );
      }) : <Skeleton count={5}/>}
    </div>
  );
};

export default SideList;
